import type { UnitInfoMobileConeInterface } from 'store/units/types';
import { UnitTypes } from 'unitData/types';
import type { MobileConeUnitInfoDataInterface } from './unitInfoData';
import { MobileUnitConeCrusherTypes } from './unitInfoData';
import * as go from 'gojs';
import type { UnitConfigParams } from 'unitData/BaseUnitConfig';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';

export class MobileConeConfig extends BaseUnitConfig {
  static getDefaultData(
    params?: UnitConfigParams,
  ): UnitInfoMobileConeInterface {
    const unitInfoData = (params?.data ??
      {}) as MobileConeUnitInfoDataInterface;
    const type = params?.unitType ?? UnitTypes.MOBILE_TRACKED_CONE;
    const feederScreenConfigurations =
      unitInfoData[MobileUnitConeCrusherTypes.US440E].configurations;
    const feederScreenData = {
      feederModel: feederScreenConfigurations.PAN_FEEDER1.model.simulationModel,
      feederScreenModel: feederScreenConfigurations.SCREEN1.model.displayName,
      screenModel:
        feederScreenConfigurations.FREEFALL_SCREEN1.models[0].simulationModel,
      feederScreenDecks: {
        decks: {
          0: {
            separationSize:
              feederScreenConfigurations.SCREEN1.defaultSeparationSize0,
          },
          1: {
            separationSize:
              feederScreenConfigurations.SCREEN1.defaultSeparationSize1,
          },
          2: {
            separationSize:
              feederScreenConfigurations.SCREEN1.defaultSeparationSize2,
          },
        },
      },
      screenDecks: {
        decks: {
          0: {
            separationSize:
              feederScreenConfigurations.FREEFALL_SCREEN1
                .defaultSeparationSize0,
          },
          1: {
            separationSize:
              feederScreenConfigurations.FREEFALL_SCREEN1
                .defaultSeparationSize1,
          },
          2: {
            separationSize:
              feederScreenConfigurations.FREEFALL_SCREEN1
                .defaultSeparationSize2,
          },
        },
      },
    };

    const wheeledScreenConfigurations =
      unitInfoData[MobileUnitConeCrusherTypes.UH312].configurations;
    const wheeledScreenData = {
      CONVENTIONAL_SCREEN1: {
        model:
          wheeledScreenConfigurations.CONVENTIONAL_SCREEN1.model.displayName,
        decks: {
          0: {
            separationSize:
              wheeledScreenConfigurations.CONVENTIONAL_SCREEN1
                .defaultSeparationSize0,
          },
          1: {
            separationSize:
              wheeledScreenConfigurations.CONVENTIONAL_SCREEN1
                .defaultSeparationSize1,
          },
          2: {
            separationSize:
              wheeledScreenConfigurations.CONVENTIONAL_SCREEN1
                .defaultSeparationSize2,
          },
          3: {
            separationSize:
              wheeledScreenConfigurations.CONVENTIONAL_SCREEN1
                .defaultSeparationSize3,
          },
        },
      },
    };

    const wheeledScreenUKConfigurations =
      unitInfoData[MobileUnitConeCrusherTypes.UK373].configurations;
    const wheeledScreenUKData = {
      CONVENTIONAL_SCREEN1: {
        model:
          wheeledScreenUKConfigurations.CONVENTIONAL_SCREEN1.model.displayName,
        simModel:
          wheeledScreenUKConfigurations.CONVENTIONAL_SCREEN1.model
            .simulationModel,
        deckOneRelieving: false,
        inclination:
          wheeledScreenUKConfigurations.CONVENTIONAL_SCREEN1.defaultInclination,
        materialType: {
          name: wheeledScreenUKConfigurations.CONVENTIONAL_SCREEN1
            .defaultRockMaterialName,
          value:
            wheeledScreenUKConfigurations.CONVENTIONAL_SCREEN1
              .defaultRockMaterialValue,
        },
        decks: {
          0: {
            separationSize:
              wheeledScreenConfigurations.CONVENTIONAL_SCREEN1
                .defaultSeparationSize0,
            screeningMediaId: {
              name: wheeledScreenUKConfigurations.CONVENTIONAL_SCREEN1
                .defaultMediaDeck1Name,
              value:
                wheeledScreenUKConfigurations.CONVENTIONAL_SCREEN1
                  .defaultMediaDeck1Value,
            },
            overUnderSize: {
              name: wheeledScreenUKConfigurations.CONVENTIONAL_SCREEN1
                .defaultOverUnderSizeDeck1Name,
              value:
                wheeledScreenUKConfigurations.CONVENTIONAL_SCREEN1
                  .defaultOverUnderSizeDeck1Value,
            },
          },
          1: {
            separationSize:
              wheeledScreenConfigurations.CONVENTIONAL_SCREEN1
                .defaultSeparationSize1,
            screeningMediaId: {
              name: wheeledScreenUKConfigurations.CONVENTIONAL_SCREEN1
                .defaultMediaDeck2Name,
              value:
                wheeledScreenUKConfigurations.CONVENTIONAL_SCREEN1
                  .defaultMediaDeck2Value,
            },
            overUnderSize: {
              name: wheeledScreenUKConfigurations.CONVENTIONAL_SCREEN1
                .defaultOverUnderSizeDeck2Name,
              value:
                wheeledScreenUKConfigurations.CONVENTIONAL_SCREEN1
                  .defaultOverUnderSizeDeck2Value,
            },
          },
          2: {
            separationSize:
              wheeledScreenConfigurations.CONVENTIONAL_SCREEN1
                .defaultSeparationSize2,
            screeningMediaId: {
              name: wheeledScreenUKConfigurations.CONVENTIONAL_SCREEN1
                .defaultMediaDeck3Name,
              value:
                wheeledScreenUKConfigurations.CONVENTIONAL_SCREEN1
                  .defaultMediaDeck3Value,
            },
            overUnderSize: {
              name: wheeledScreenUKConfigurations.CONVENTIONAL_SCREEN1
                .defaultOverUnderSizeDeck3Name,
              value:
                wheeledScreenUKConfigurations.CONVENTIONAL_SCREEN1
                  .defaultOverUnderSizeDeck3Value,
            },
          },
        },
      },
    };

    const wheeledFlexScreenConfigurations =
      unitInfoData[MobileUnitConeCrusherTypes.UH320_Flex].configurations;

    const wheeledFlexScreenData = {
      model:
        wheeledFlexScreenConfigurations.FREEFALL_SCREEN_SF1.model.displayName,
      directToCrusher: 100,
      decks: {
        0: {
          separationSize:
            wheeledFlexScreenConfigurations.FREEFALL_SCREEN_SF1
              .defaultSeparationSize0,
        },
        1: {
          separationSize:
            wheeledFlexScreenConfigurations.FREEFALL_SCREEN_SF1
              .defaultSeparationSize1,
        },
        2: {
          separationSize:
            wheeledFlexScreenConfigurations.FREEFALL_SCREEN_SF1
              .defaultSeparationSize2,
        },
      },
      feederScreenDecks: {
        0: {
          separationSize:
            wheeledFlexScreenConfigurations.SCREEN1.defaultSepSize,
        },
        1: {
          separationSize:
            wheeledFlexScreenConfigurations.SCREEN2.defaultSeparationSize0,
        },
        2: {
          separationSize:
            wheeledFlexScreenConfigurations.SCREEN2.defaultSeparationSize1,
        },
      },
    };

    if (type === UnitTypes.MOBILE_TRACKED_CONE) {
      const modelConfigurations =
        unitInfoData[MobileUnitConeCrusherTypes.QH332].configurations;

      return {
        ...BaseUnitConfig.getBaseDefaults(),
        modelName: MobileUnitConeCrusherTypes.QH332,
        configuration: modelConfigurations.configurationOptions[0],
        numberOfPorts: 1,
        moisture: 0,
        newMoisture: false,
        display: {
          ...BaseUnitConfig.getDefaultDisplay(),
          displayConfig: false,
          displayLoad: true,
          displayFeederModel: false,
          displayFeederScreenModel: false,
          displayFeederScreenSeparation: false,
          displayCrusherModel: false,
          displayCrusherCss: false,
          displayCrusherThrow: false,
          displayCrusherConcave: false,
          displayCrusherMantle: false,
          displayScreenModel: false,
          displayScreenSeparation: false,
          displayReturnFlow: false,
        },
        CONE1: {
          modelName: modelConfigurations.CONE1.model.simulationModel,
          css: modelConfigurations.CONE1.defaultCss,
          mantle: modelConfigurations.CONE1.defaultMantle,
          concave: modelConfigurations.CONE1.defaultConcave,
          unitThrow: modelConfigurations.CONE1.defaultThrow,
        },
        SCREEN1: {
          model: modelConfigurations.SCREEN1.model.displayName,
          decks: {
            0: {
              separationSize:
                modelConfigurations.SCREEN1.decks[0].defaultSeparationSize,
            },
            1: {
              separationSize:
                modelConfigurations.SCREEN1.decks[1].defaultSeparationSize,
            },
          },
        },
        SPLIT1: {
          returnToCrusher: 0,
          directToCrusher: 0,
        },
        hangingScreen: {
          decks: {
            0: {
              separationSize:
                modelConfigurations.SCREEN1.decks[0].defaultSeparationSize,
            },
          },
        },
        feederScreen: feederScreenData,
        wheeledScreen: wheeledScreenData,
        wheeledScreenUK: wheeledScreenUKData,
        wheeledFlexScreen: wheeledFlexScreenData,
        parallelUnits: 1,
      };
    } else {
      const modelConfigurations =
        unitInfoData[MobileUnitConeCrusherTypes.UH312].configurations;
      return {
        ...BaseUnitConfig.getBaseDefaults(),
        modelName: MobileUnitConeCrusherTypes.UH312,
        configuration: modelConfigurations.configurationOptions[0],
        numberOfPorts: 4,
        newMoisture: false,
        display: {
          ...BaseUnitConfig.getDefaultDisplay(),
          displayConfig: false,
          displayLoad: true,
          displayFeederModel: false,
          displayFeederScreenModel: false,
          displayFeederScreenSeparation: false,
          displayCrusherModel: false,
          displayCrusherCss: false,
          displayCrusherThrow: false,
          displayCrusherConcave: false,
          displayCrusherMantle: false,
          displayScreenModel: false,
          displayScreenSeparation: false,
          displayReturnFlow: false,
        },
        CONE1: {
          modelName: modelConfigurations.CONE1.model.simulationModel,
          css: modelConfigurations.CONE1.defaultCss,
          mantle: modelConfigurations.CONE1.defaultMantle,
          concave: modelConfigurations.CONE1.defaultConcave,
          unitThrow: modelConfigurations.CONE1.defaultThrow,
        },
        SCREEN1: {
          model: modelConfigurations.CONVENTIONAL_SCREEN1.model.displayName,
          decks: {
            0: {
              separationSize:
                modelConfigurations.CONVENTIONAL_SCREEN1.defaultSeparationSize0,
            },
            1: {
              separationSize: 0,
            },
          },
        },
        SPLIT1: {
          returnToCrusher: modelConfigurations.SPLIT1.defaultAmountRight,
          directToCrusher: 100,
        },
        hangingScreen: {
          decks: {
            0: {
              separationSize: 40,
            },
          },
        },
        feederScreen: feederScreenData,
        wheeledScreen: wheeledScreenData,
        wheeledScreenUK: wheeledScreenUKData,
        wheeledFlexScreen: wheeledFlexScreenData,
        parallelUnits: 1,
      };
    }
  }

  static getNumberOfPorts(model?: string, config?: number): number {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return getNumberOfPorts(model!, config!);
  }
}

export const mobileConeConfig = new MobileConeConfig();

const {
  QH441,
  QH443E,
  QH332,
  QS332,
  UH311,
  UH312,
  UH412,
  UH316,
  US316,
  UH320_Flex,
  UH440i,
  US440i,
  UH440E,
  US440E,
  UH640,
  UK373,
  UH373,
  UH573,
  US640E,
  US373,
} = MobileUnitConeCrusherTypes;

export const getNumberOfPorts = (model: string, configKey: number) => {
  const isKey = (...keys: number[]) => keys.includes(configKey);
  switch (model) {
    case QH441:
      if (isKey(0, 2)) {
        return 1;
      }
      return 2;
    case QH332:
    case QS332:
      if (isKey(0, 3)) {
        return 1;
      } else if (isKey(2)) {
        return 3;
      }
      return 2;
    case UH311:
    case UH312:
    case UH412:
      if (isKey(2, 6)) {
        return 2;
      } else if (isKey(1, 3, 5, 7)) {
        return 3;
      }
      return 4;
    case UH316:
    case US316:
      if (isKey(0, 2)) {
        return 3;
      }
      return 2;
    case UH320_Flex:
      if (isKey(2)) {
        return 3;
      } else if (isKey(1)) {
        return 5;
      }
      return 4;
    case UH440i:
    case US440i:
      if (isKey(1)) {
        return 2;
      }
      return 1;
    case UH440E:
    case US440E:
    case UH640:
      if (isKey(2)) {
        return 2;
      }
      return 3;
    case UK373:
      return 3;
    case UH373:
    case UH573:
    case US640E:
    case US373:
    case QH443E:
      return 1;
    default:
      return 2;
  }
};

export const getNumberOfScreenDecks = (model: string, configKey: number) => {
  if (model === MobileUnitConeCrusherTypes.QH441) {
    if (configKey === 0) {
      return 0;
    } else {
      return 1;
    }
  } else {
    if (configKey === 0) {
      return 0;
    } else {
      return 2;
    }
  }
};

export const alignPorts = (
  mirrored: boolean,
  model: string,
  configKey: number,
  portIndex: number,
) => {
  const getXMirrored = (x: number) => {
    if (mirrored) {
      return 1 - x;
    }
    return x;
  };

  if (
    model === MobileUnitConeCrusherTypes.QH332 ||
    model === MobileUnitConeCrusherTypes.QS332
  ) {
    const positionOne = new go.Spot(getXMirrored(1), 10 / 12);
    const positionTwo = new go.Spot(getXMirrored(11 / 12), 0);
    const positionThree = new go.Spot(getXMirrored(5 / 12), 1);

    switch (portIndex) {
      case 0:
        if (configKey === 0 || configKey === 3) {
          return positionOne;
        } else if (configKey === 1) {
          return positionTwo;
        } else if (configKey === 4) {
          return positionThree;
        } else {
          return positionThree;
        }
      case 1:
        if (configKey === 1) {
          return positionOne;
        } else if (configKey === 4) {
          return positionOne;
        } else {
          return positionTwo;
        }
      case 2:
        return positionOne;
    }
  } else if (model === MobileUnitConeCrusherTypes.QH441) {
    const positionOne = new go.Spot(getXMirrored(1), 10 / 12);
    const positionTwo = new go.Spot(getXMirrored(11 / 12), 0);

    switch (portIndex) {
      case 0:
        if (configKey === 1) {
          return positionTwo;
        }
        return positionOne;
      case 1:
        return positionOne;
    }
  } else if (
    model === MobileUnitConeCrusherTypes.US440E ||
    model === MobileUnitConeCrusherTypes.UH440E ||
    model === MobileUnitConeCrusherTypes.UH640
  ) {
    const positionOne = new go.Spot(getXMirrored(6 / 12), 1);
    const positionTwo = new go.Spot(getXMirrored(1), 10 / 12);
    const positionThree = new go.Spot(getXMirrored(0), 6 / 12);

    switch (portIndex) {
      case 0:
        return positionTwo;
      case 1:
        if (configKey === 2) {
          return positionThree;
        }
        return positionOne;
      case 2:
        return positionThree;
    }
  } else if (
    model === MobileUnitConeCrusherTypes.UH440i ||
    model === MobileUnitConeCrusherTypes.US440i
  ) {
    const positionOne = new go.Spot(getXMirrored(1), 10 / 12);
    const positionTwo = new go.Spot(getXMirrored(0), 8 / 12);

    switch (portIndex) {
      case 0:
        if (configKey === 1) {
          return positionTwo;
        }
        return positionOne;
      case 1:
        return positionOne;
    }
  } else if (
    model === MobileUnitConeCrusherTypes.UH311 ||
    model === MobileUnitConeCrusherTypes.UH312 ||
    model === MobileUnitConeCrusherTypes.UH412
  ) {
    const positionOne = new go.Spot(getXMirrored(1), 4 / 12);
    const positionTwo = new go.Spot(getXMirrored(1), 6 / 12);
    const positionThree = new go.Spot(getXMirrored(1), 8 / 12);
    const positionFour = new go.Spot(getXMirrored(1), 10 / 12);

    switch (portIndex) {
      case 0:
        if (configKey === 2 || configKey === 6) {
          return positionThree;
        } else if (
          configKey === 1 ||
          configKey === 3 ||
          configKey === 5 ||
          configKey === 7
        ) {
          return positionTwo;
        } else {
          return positionOne;
        }
      case 1:
        if (configKey === 2 || configKey === 6) {
          return positionFour;
        } else if (
          configKey === 1 ||
          configKey === 3 ||
          configKey === 5 ||
          configKey === 7
        ) {
          return positionThree;
        } else {
          return positionTwo;
        }
      case 2:
        if (
          configKey === 1 ||
          configKey === 3 ||
          configKey === 5 ||
          configKey === 7
        ) {
          return positionFour;
        } else {
          return positionThree;
        }
      case 3:
        return positionFour;
    }
    return positionFour;
  } else if (
    model === MobileUnitConeCrusherTypes.UH316 ||
    model === MobileUnitConeCrusherTypes.US316
  ) {
    const positionTwo = new go.Spot(getXMirrored(1), 6 / 12);
    const positionThree = new go.Spot(getXMirrored(1), 8 / 12);
    const positionFour = new go.Spot(getXMirrored(1), 10 / 12);

    switch (portIndex) {
      case 0:
        if (configKey === 1 || configKey === 3) {
          return positionThree;
        } else {
          return positionTwo;
        }
      case 1:
        if (configKey === 1 || configKey === 3) {
          return positionFour;
        } else {
          return positionThree;
        }
      case 2:
        return positionFour;
    }
  } else if (model === MobileUnitConeCrusherTypes.UH320_Flex) {
    const positionOne = new go.Spot(getXMirrored(0), 4 / 12);
    const positionTwo = new go.Spot(getXMirrored(11 / 12), 0);
    const positionThree = new go.Spot(getXMirrored(4 / 12), 1);
    const positionFour = new go.Spot(getXMirrored(1), 10 / 12);
    const positionFive = new go.Spot(getXMirrored(0), 2 / 12);

    switch (portIndex) {
      case 0:
        if (configKey === 0 || configKey === 1) {
          return positionOne;
        } else {
          return positionTwo;
        }
      case 1:
        if (configKey === 0 || configKey === 1) {
          return positionTwo;
        } else if (configKey === 2) {
          return positionFour;
        } else {
          return positionThree;
        }
      case 2:
        if (configKey === 0 || configKey === 3) {
          return positionFour;
        } else if (configKey === 1) {
          return positionThree;
        } else {
          return positionFive;
        }
      case 3:
        if (configKey === 0 || configKey === 3) {
          return positionFive;
        } else {
          return positionFour;
        }
      case 4:
        return positionFive;
    }
  } else if (model === MobileUnitConeCrusherTypes.UK373) {
    const positionTwo = new go.Spot(getXMirrored(8 / 12), 0);
    const positionThree = new go.Spot(getXMirrored(6 / 12), 1);
    const positionFour = new go.Spot(getXMirrored(1), 11 / 12);

    switch (portIndex) {
      case 0:
        return positionTwo;
      case 1:
        return positionThree;
      case 2:
        return positionFour;
    }
  } else if (
    model === MobileUnitConeCrusherTypes.UH373 ||
    model === MobileUnitConeCrusherTypes.US373 ||
    model === MobileUnitConeCrusherTypes.US640E
  ) {
    const positionTwo = new go.Spot(getXMirrored(1), 8 / 12);

    return positionTwo;
  } else if (model === MobileUnitConeCrusherTypes.UH573) {
    const positionTwo = new go.Spot(getXMirrored(5 / 12), 1);

    return positionTwo;
  } else if (model === MobileUnitConeCrusherTypes.QH443E) {
    const positionOne = new go.Spot(getXMirrored(1), 10 / 12);

    return positionOne;
  }
};
